import * as Yup from 'yup';

// Tipo de gestión Defensa Penal (IND 207): el botón «Informe Inicial» y la pastilla del historial solo aplican a estos casos.
export const ID_TIPO_GESTION_DEFENSA_PENAL = 207006;

// Estados del informe (IND 355).
export const ESTADO_BORRADOR = 355001;
export const ESTADO_ENVIADO = 355002;
export const ESTADO_REVISADO = 355003;

// Valores que devuelve el lambda defensa-fnc-obtiene-informe-penal (modo `ultimo`).
export const MODO_EDITABLE = 'EDITABLE';
export const MODO_SOLO_LECTURA = 'SOLO_LECTURA';
export const MODO_NUEVA_VERSION = 'NUEVA_VERSION';
export const ETIQUETA_ACTUALIZAR_INFORME = 'ACTUALIZAR_INFORME';

// Textos fijos del front (no se agregan claves a cfg_formularios_web).
export const TEXTO_BOTON_INFORME_INICIAL = 'Informe Inicial';
export const TEXTO_BOTON_ACTUALIZAR_INFORME = 'Actualizar Informe';
export const TEXTO_BOTON_REINTENTAR_INFORME = 'Reintentar Informe';
export const TITULO_INFORME_INICIAL = 'INFORME INICIAL - IMPLICADO';
export const TITULO_ACTUALIZAR_INFORME = 'ACTUALIZAR INFORME DEFENSA PENAL';

// Sección 7 en la vista del abogado (respuesta del analista, Jira 58067, punto 19): no se muestra en el informe inicial (versión 1);
// desde la versión 2 se muestra solo de lectura, con este mensaje mientras el informe esté «Enviado» y sin revisar.
export const MSG_SECCION7_PENDIENTE = 'Pendiente de revisión por el analista';

// Regla de negocio agregada por el analista (Jira 58067): con el último informe «Enviado» el abogado no puede registrar otro y se le
// presenta este mensaje (el formulario se abre solo para visualizar).
export const MSG_INFORME_PENDIENTE_REVISION = 'Informe actual pendiente de revisión por el analista.';

// ─── Obligatoriedad (plan §5.4; D3: dos constantes espejo, la otra está en el lambda de escritura) ───────────────
// Se actualizan JUNTAS cuando el analista responda el punto 9 de Jira 58061.
// Guardar Borrador: lo que exige el DDL (nroLesionados y nroMuertos llevan 0 por defecto).
export const OBLIGATORIOS_BORRADOR = ['tipoDelito', 'intervinoTransito', 'gradoResponsabilidad'];
// Enviar: los anteriores más la propuesta del punto 9.
export const OBLIGATORIOS_ENVIAR = [
    ...OBLIGATORIOS_BORRADOR,
    'agravante', 'licenciaVigente', 'categoriaLicencia', 'vigenciaLicencia',
    'hipotesisAsegurado', 'hipotesisTercero', 'hechos', 'estrategia'
];
// Fiscalía y radicado: obligatorios en Enviar solo si el caso tiene al menos una fiscalía registrada.
export const OBLIGATORIOS_ENVIAR_CON_FISCALIA = ['instanciaJudicial', 'radicado'];

export const ACCION_BORRADOR = 'BORRADOR';
export const ACCION_ENVIAR = 'ENVIAR';

// Esquema Yup según la acción. Los valores del formulario son texto (los combos llegan como String).
export const esquemaInforme = (accion, hayFiscalias) => {
    const obligatorios = accion === ACCION_ENVIAR
        ? [...OBLIGATORIOS_ENVIAR, ...(hayFiscalias ? OBLIGATORIOS_ENVIAR_CON_FISCALIA : [])]
        : OBLIGATORIOS_BORRADOR;

    const forma = {
        nroLesionados: Yup.number().typeError('Debe ser un número.').integer('Debe ser entero.').min(0, 'No puede ser negativo.'),
        nroMuertos: Yup.number().typeError('Debe ser un número.').integer('Debe ser entero.').min(0, 'No puede ser negativo.'),
        hechos: Yup.string().max(5000, 'Máximo 5000 caracteres.'),
        estrategia: Yup.string().max(2000, 'Máximo 2000 caracteres.')
    };

    obligatorios.forEach((campo) => {
        const base = forma[campo] || Yup.string();
        forma[campo] = base.required('Campo obligatorio.');
    });

    return Yup.object().shape(forma);
};
